import { ClientWorkspace, ClientWorkspaceType } from '../workspace.type';

export const unassignedWorkspaceId = '-1';
export const trashedWorkspaceId = '-2';

export function workspaceUnassignedNodesTransformer(count: number): ClientWorkspace {
	return {
		id: unassignedWorkspaceId,
		type: ClientWorkspaceType.UNASSIGNED_NODES,
		name: 'Unassigned Nodes',
		description: '',
		count,
	};
}

export function workspaceTrashedNodesTransformer(count: number): ClientWorkspace {
	return {
		id: trashedWorkspaceId,
		type: ClientWorkspaceType.TRASHED_NODES,
		name: 'Trash',
		description: '',
		count,
	};
}
